export default __webpack_public_path__ + "static/media/license_music_info.b3cae54c.png";